<template>
  <div
    class="value-with-label"
    :class="rootClasses"
  >
    <span class="value-with-label__first-item">
      <slot name="label">
        <EllipsisLabel
          v-if="firstOfValue"
          alwaysShowTooltip
          onTopOfEverything
          :content="firstOfValue"
        />
      </slot>
    </span>

    <Tooltip
      v-if="labelCount"
      :overlayClassName="tooltipClass"
      :placement="tooltipPlacement"
      :align="tooltipAlign"
    >
      <template #title>
        <ul class="value-with-label__hidden-items">
          <li
            v-for="(item, index) in tooltipValue"
            :key="index"
            class="value-with-label__hidden-item"
          >
            <template v-if="!noTooltipItemsCounter">
              {{ index + 1 }}.
            </template>
            <slot
              name="tooltipItem"
              :item="item"
              :index="index"
            >
              {{ item }}
            </slot>
          </li>
        </ul>
      </template>
      <div class="value-with-label__count">
        +{{ labelCount }}
      </div>
    </Tooltip>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  PropType,
} from 'vue';

import { Tooltip } from '@/ui';
import { joinString } from '@/utils';
import EllipsisLabel from '@/components/EllipsisLabel/index.vue';
import { TAling, EPopoverPlacement } from '@/ui/types';

export default defineComponent({
  name: 'ValueWithLabel',
  components: {
    Tooltip,
    EllipsisLabel,
  },
  props: {
    value: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
    spaceBetween: {
      type: Boolean,
      default: false,
    },
    tooltipAlign: {
      type: Object as PropType<TAling>,
      default: () => {},
    },
    tooltipExtraClasses: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    tooltipPlacement: {
      type: String as PropType<EPopoverPlacement>,
      default: EPopoverPlacement.top,
    },
    separateLabel: {
      type: Boolean,
      default: false,
    },
    noTooltipItemsCounter: {
      type: Boolean,
      default: true,
    },
    noTooltipMaxWidth: {
      type: Boolean,
      default: false,
    },
    firsOfValueCustomField: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const firstOfValue = computed(() => {
      if (Array.isArray(props.value)) {
        if (props.firsOfValueCustomField) return props.value[0][props.firsOfValueCustomField];

        return props.value[0];
      }

      return null;
    });

    const labelCount = computed(() => (
      Array.isArray(props.value) && firstOfValue.value ? props.value.length - 1 : null
    ));

    const tooltipValue = computed(() => (
      props.separateLabel ? props.value.slice(1) : props.value
    ));

    const rootClasses = computed(() => (
      { 'value-with-label__with-space-between': props.spaceBetween }
    ));

    const tooltipClass = computed(() => {
      const classes = [
        'value-with-label__tooltip',
        ...props.tooltipExtraClasses,
      ];

      if (props.noTooltipMaxWidth) {
        classes.push('value-with-label__tooltip_no-tooltip-max-width');
      }

      return joinString(classes);
    });

    return {
      firstOfValue,
      labelCount,
      rootClasses,
      tooltipClass,
      tooltipValue,
      EPopoverPlacement,
    };
  },
});
</script>

<style lang="scss" src="./styles.scss" />
